import { unityColorTokens } from '../../unityTokens';
import { ChronosphereColor } from './types';

export const unityOrange: ChronosphereColor = {
  50: unityColorTokens['--color-orange-50'],
  100: unityColorTokens['--color-orange-100'],
  150: unityColorTokens['--color-orange-200'],
  200: unityColorTokens['--color-orange-300'],
  300: unityColorTokens['--color-orange-400'],
  400: unityColorTokens['--color-orange-500'],
  500: unityColorTokens['--color-orange-600'],
  600: unityColorTokens['--color-orange-700'],
  700: unityColorTokens['--color-orange-800'],
  800: unityColorTokens['--color-orange-900'],
  850: unityColorTokens['--color-orange-950'],
  900: unityColorTokens['--color-orange-1000'],
  950: unityColorTokens['--color-orange-1000'],
};
export const orange: ChronosphereColor = {
  50: '#FFF5E8',
  100: '#FFECD2',
  150: '#FFD9A4',
  200: '#FFC577',
  300: '#FFB049',
  400: '#FF9514',
  500: '#E67700',
  600: '#B85C00',
  700: '#97520C',
  800: '#6D4009',
  850: '#4D3008',
  900: '#332006',
  950: '#1A1003',
};
